





















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Number from "@/shared/filters/Number";
import Pagination from "@/views/components/Pagination.vue";
import InputNumber from "@/views/components/input/InputNumber.vue";
import { CommonService } from "@/services/Common.service";
import { Buhin, Work } from "../models/Buhin";
import InputString from "@/views/components/input/InputString.vue";
import { BuhinsService } from "@/services/Buhins.service.ts";
import { KyotenData } from "@/models/KyotenData";
import { Utils } from "@/services/utils";
import ComponentWithGroupShaten from "@/views/components/ComponentWithGroupShaten";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import { ShatenService } from "@/services/shaten.service";

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination
  },
  mixins: [FilterSelectBox]
})
export default class BuhinDetail extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;
  selectedTaxRate: number | null = null;
  commonService = new CommonService();
  public buhinService = new BuhinsService();
  loading: boolean = false;
  buhinList: any[] = [];
  buhinPageList: Buhin[] = [];
  buhinData: Buhin = {
    buhinNm: "",
    kingaku: null,
    kingakuZk: null,
    buhinBunruiCd: "",
    workCd: [],
    fuelKbn: null,
    listKingaku: [],
    defaultValue: null,
    defaultValueType: null
  };

  buhinEditData: Buhin = {
    buhinNm: "",
    kingaku: null,
    kingakuZk: null,
    work: [],
    listKingaku: [],
    defaultValue: null,
    defaultValueType: null
    // 2022-01-31 morisako kobac-free add [START]
    , seibiKbn: 0
    , sknInspectSeibiBuhinFeeExtensionId: null
    , isFree: null
    , isDiscount: null
    // 2022-01-31 morisako kobac-free add [END]
  };

  workFilter: any = {
    workCd: "",
    workNm: ""
  };

  seibiList: Work[] = [];
  seibiSelected: Work[] = [];
  saveSeibiSelected: Work[] = [];

  bunruiList: any = [];
  jidoushaShubetsuList: any = [];
  fuelList: any = [];
  disableBtnAdd: boolean = true;
  disableBtnEdit: boolean = true;
  public dialogFormVisible: boolean = false;
  public showWorkDialog: boolean = false;
  public selectWorkStep: number = 1;
  public showShubetsuDialog: boolean = false;
  public showShubetsuDialog2: boolean = false;
  public showWorkListDialog: boolean = false;
  saveShubetsuKingaku: any = [];
  taxList: any = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  shouhizeiMarumeKbn: number = 0;
  environment: any;
  defaultValueTypes: any = [];
  idEdit = -1;
  showConfirmDelete = false;
  idDelete = -1;
  util: Utils = new Utils();
  bunruiSelectedList: any = [];
  versionList: any = [];
  feeList: any = [];
  shatenService: ShatenService = new ShatenService();
  hasExtensionId = false;
  buhinFilterList: any = [];
  activeBuhinShubetsu = "";

  private mounted() {
    this.form = {
      kyotenCd: "",
      groupCd: "",
      shatenCd: "",
      version: "",
      sknInspectSeibiFeeId: ""
    };

    this.getTaxList();
    this.getBuhinBunrui();
    // this.getKbnSkns("fuelList", "skn_fuel_kbn");
    this.getKbnSkns("jidoushaShubetsuList", "skn_jidousha_shubetsu", "7101");
    this.getKbnSkns("defaultValueTypes", "skn_buhin_default_value_type_kbn");
    this.getMarumeKbn();
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          if (res3 && res3.length > 0) {
            this.form.kyotenCd = localStorage.getItem("kyotenCd");
            this.getVersionList().then(() => {
              if (this.versionList.length === 1) {
                this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
                // this.getBuhinList();
                this.getFeeList();
              }
            });
          }
        });
      });
    });
  }

  async getMarumeKbn() {
    this.environment = await this.commonService.getEnvironment();
    if (this.environment) {
      this.shouhizeiMarumeKbn = this.environment.shouhizeiMarumeKbn;
    }
  }

  public async selectKyoten() {
    this.getVersionList();
  }

  public async getKyotenDataList() {
    this.form.version = "";
    this.form.sknInspectSeibiFeeId = "";
    const response = await this.commonService.getKyotenHasVersion(
      this.form.groupCd,
      this.form.shatenCd
    );
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
    if (this.kyotenDataList.length === 0) {
      this.form.kyotenCd = "";
      this.getVersionList();
    }
    return response;
  }

  async selectGroup1() {
    this.form.version = "";
    this.versionList = [];
    this.selectGroup();
  }

  async getVersionList() {
    this.form.version = "";
    this.form.sknInspectSeibiFeeId = "";
    const res = await this.commonService.getHanyouSeibiVersion(
      this.form.groupCd,
      this.form.shatenCd,
      this.form.kyotenCd
    );
    this.$set(this, "versionList", res);
    if (this.versionList.length === 1) {
      this.form.version = this.versionList[0].sknHanyouSeibiVersionId;
      this.getFeeList();
    } else if (this.versionList.length === 0) {
      this.getFeeList();
    }
  }

  selectVersion() {
    this.getFeeList();
  }

  public async getTaxList() {
    const response = await this.commonService.getTaxList();
    if (response) {
      this.$set(this, "taxList", response);
      const tempTax: any = this.taxList.filter(
        (data: any) => data.isCurrent == 1
      );
      if (tempTax.length !== 0) {
        this.selectedTaxRate = tempTax[0].rateExtremeType;
      }
    }
  }

  getBuhinItem(isEdit: boolean) {
    let item: Buhin;
    if (isEdit) {
      item = { ...this.buhinEditData };
    } else {
      item = { ...this.buhinData };
    }
    return item;
  }

  focusOutZn(isEdit: boolean) {
    this.focusOutPrice(isEdit, false);
  }

  focusOutZk(isEdit: boolean) {
    this.focusOutPrice(isEdit, true);
  }

  focusOutZn2(isEdit: boolean, row: any) {
    this.focusOutPrice2(isEdit, false, row);
  }

  focusOutZk2(isEdit: boolean, row: any) {
    this.focusOutPrice2(isEdit, true, row);
  }

  async focusOutPrice(isEdit: boolean, isZk: boolean) {
    let buhin: Buhin = this.getBuhinItem(isEdit);
    if (isZk) {
      if (buhin.kingakuZk) {
        let zn = await this.commonService.calcZeinuki(
          buhin.kingakuZk,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(buhin, "kingaku", zn);
      } else {
        this.$set(buhin, "kingaku", null);
        this.$set(buhin, "kingakuZk", null);
      }
    } else {
      if (buhin.kingaku) {
        let zk = await this.commonService.calcZeikomi(
          buhin.kingaku,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(buhin, "kingakuZk", zk);
      } else {
        this.$set(buhin, "kingaku", null);
        this.$set(buhin, "kingakuZk", null);
      }
    }
    this.checkDisabled(isEdit);
  }

  async focusOutPrice2(isEdit: boolean, isZk: boolean, row: any) {
    if (isZk) {
      if (row.kingakuZk) {
        let zn = await this.commonService.calcZeinuki(
          row.kingakuZk,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(row, "kingaku", zn);
      } else {
        this.$set(row, "kingaku", 0);
        this.$set(row, "kingakuZk", 0);
      }
    } else {
      if (row.kingaku) {
        let zk = await this.commonService.calcZeikomi(
          row.kingaku,
          this.selectedTaxRate,
          this.shouhizeiMarumeKbn
        );
        this.$set(row, "kingakuZk", zk);
      } else {
        this.$set(row, "kingaku", 0);
        this.$set(row, "kingakuZk", 0);
      }
    }
  }

  checkDisabled(isEdit: boolean) {
    let disabled = false;
    let btn = "";
    if (isEdit) {
      btn = "disableBtnEdit";
      if (this.buhinEditData.buhinNm === "") {
        disabled = true;
      }
    } else {
      btn = "disableBtnAdd";
      if (
        this.buhinData.buhinNm === "" ||
        this.buhinData.buhinBunruiCd === ""
      ) {
        disabled = true;
      }
    }
    this.$set(this, btn, disabled);
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit2() {
    if (this.buhinData.buhinNm && this.buhinData.buhinBunruiCd) {
      this.loading = true;
      let tempShubetsu: any = [];
      if (this.saveShubetsuKingaku && this.saveShubetsuKingaku.length !== 0) {
        tempShubetsu = this.saveShubetsuKingaku.map((item: any) => {
          return {
            jidoushaShubetsuKbn: item.jidoushaShubetsuKbn,
            kingaku: item.kingaku,
            shiyouKbn: item.shiyouKbn
          };
        });
      } else {
        this.jidoushaShubetsuList.forEach((element: any) => {
          tempShubetsu.push({
            jidoushaShubetsuKbn: element.kbnKey,
            kingaku: 0,
            shiyouKbn: 1
          });
        });
      }
      const data = {
        buhinBunruiCd: this.buhinData.buhinBunruiCd,
        buhinNm: this.buhinData.buhinNm,
        listKingaku: tempShubetsu,
        defaultValue: this.buhinData.defaultValue,
        defaultValueType: this.buhinData.defaultValueType
        // sknInspectSeibiFeeId: this.form.sknInspectSeibiFeeId
      };
      this.createBuhinItem({ ...data });
    }
  }

  public editBuhinItem() {
    this.loading = true;
    if (this.buhinEditData.id && this.buhinEditData.buhinNm) {
      const data = {
        id: this.buhinEditData.id,
        buhinNm: this.buhinEditData.buhinNm,
        kingaku: this.buhinEditData.kingaku,
        sknInspectSeibiFeeId: this.form.sknInspectSeibiFeeId
      };
      this.addBuhinItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  public updateBuhin() {
    if (this.buhinEditData.id && this.buhinEditData.buhinNm) {
      this.loading = true;
      let tempKingaku: any = [];
      if (
        this.buhinEditData.listKingaku &&
        this.buhinEditData.listKingaku.length !== 0
      ) {
        tempKingaku = this.util.deepCopy(this.buhinEditData.listKingaku);
      }

      const data = {
        id: this.buhinEditData.id,
        buhinNm: this.buhinEditData.buhinNm,
        listKingaku: tempKingaku,
        defaultValue: this.buhinEditData.defaultValue,
        defaultValueType: this.buhinEditData.defaultValueType,
        sknInspectSeibiFeeId: this.form.sknInspectSeibiFeeId
        // 2022-01-31 morisako kobac-free add [START]
        , seibiKbn: this.buhinEditData.seibiKbn
        , sknInspectSeibiBuhinFeeExtensionId: this.buhinEditData.sknInspectSeibiBuhinFeeExtensionId
        , isFree: this.buhinEditData.isFree
        , isDiscount: this.buhinEditData.isDiscount
        // 2022-01-31 morisako kobac-free add [END]
      };
      this.addBuhinItem({ ...data });
    }
    // this.showShubetsuDialog2 = false;
    this.idEdit = -1;
  }

  public async getBuhinBunrui() {
    const response = await this.buhinService.getBuhinBunrui();
    if (response) {
      this.$set(this, "bunruiList", [...response]);
    } else {
      this.$set(this, "bunruiList", []);
    }
  }

  public async getKbnSkns(nameKbn: string, sknTitle: string, kbnCd?: string) {
    const response = await this.commonService.getKbnSkns(sknTitle, kbnCd);
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.num > b.num ? 1 : -1));
      this.$set(this, nameKbn, [...data]);
    } else {
      this.$set(this, nameKbn, []);
    }
  }

   public async getBuhinList(isInit = false) {
    this.$set(this, "loading", true);
    let param = null;
    if (!this.form.version) {
      const { groupCd, shatenCd } = this.form;
      param = { groupCd, shatenCd };
    }
    const response = await this.buhinService.getBuhins(
      this.form.version,
      param,
      this.form.sknInspectSeibiFeeId
    );
    this.$set(this, "loading", false);
    if (response) {
      const list = this.jidoushaShubetsuList.map((e: any) => e.kbnKey);
      const buhinList = response.map((item: any) => {
        item.items.map((bunrui: any) =>
          bunrui.items.map((buhin: any) =>
            buhin.listKingaku.sort(
              (a: any, b: any) =>
                list.indexOf(a.jidoushaShubetsuKbn) -
                list.indexOf(b.jidoushaShubetsuKbn)
            )
          )
        );
        return item;
      });
      this.$set(this, "buhinList", buhinList);
      if (isInit) {
        this.setActiveShubetsu();
      }
    } else {
      this.$set(this, "buhinList", []);
    }
    this.checkDisabled(false);
  }

  public async getSeibiList() {
    const response = await this.buhinService.getSeibi(
      this.workFilter.workCd,
      this.workFilter.workNm
    );
    this.$set(this, "loading", false);
    if (response) {
      const data = response.map((e: any) => {
        let temp: boolean = false;
        this.seibiSelected.filter((val: any) => {
          if (e.workCd == val.workCd) {
            temp = true;
          }
        });
        return {
          workCd: e.workCd,
          workNm: e.sknInspectSeibiTitle,
          jidoushaShubetsu: [],
          isCheck: temp
        };
      });
      this.$set(this, "seibiList", [...data]);
    } else {
      this.$set(this, "seibiList", []);
    }
    this.checkDisabled(false);
  }

  public async addBuhinItem(data: any) {
    const response = await this.buhinService.editBuhins(data);
    if (response) {
      this.getBuhinList();
    } else {
      this.delay(1000);
    }
  }

  public async createBuhinItem(data: any) {
    let param = null;
    if (!this.form.version) {
      const { groupCd, shatenCd } = this.form;
      param = { groupCd, shatenCd };
    }
    const response = await this.buhinService.addBuhins(
      data,
      this.form.version,
      param
    );
    this.clearInput();
    if (response) {
      this.getBuhinList();
    }
  }

  onConfirmDelete(id: number) {
    this.showConfirmDelete = true;
    this.idDelete = id;
  }

  public async delBuhinItem() {
    if (this.idDelete) {
      this.loading = true;
      const response = await this.buhinService.deleteBuhins(this.idDelete, this.form.sknInspectSeibiFeeId);
      if (response) {
        this.getBuhinList();
      } else {
        this.delay(1000);
      }
    }
    this.showConfirmDelete = false;
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.buhinEditData = { ...rowData };
    if (this.buhinEditData.kingaku && !this.buhinEditData.kingakuZk) {
      this.focusOutZn(true);
    } else if (!this.buhinEditData.kingaku && this.buhinEditData.kingakuZk) {
      this.focusOutZk(true);
    }
  }

  addShubetsu(row: any) {
    const lastIndex: number = row.jidoushaShubetsu.length;
    if (lastIndex !== 0) {
      if (row.jidoushaShubetsu[lastIndex - 1].jidoushaShubetsuKbn) {
        row.jidoushaShubetsu.push({
          jidoushaShubetsuKbn: null,
          kousuu: 0,
          koukanMeyasuTime: 0
        });
      }
    } else if (lastIndex === 0) {
      row.jidoushaShubetsu.push({
        jidoushaShubetsuKbn: null,
        kousuu: 0,
        koukanMeyasuTime: 0
      });
    }
  }

  workDetailPage() {
    if (this.seibiSelected && this.seibiSelected.length !== 0) {
      this.seibiSelected.forEach(e => {
        this.chosenWork(e);
      });
    }
    this.selectWorkStep = 2;
  }

  chosenWork(row: any) {
    if (
      row.isCheck &&
      row.jidoushaShubetsu &&
      row.jidoushaShubetsu.length === 0
    ) {
      row.jidoushaShubetsu.push({
        jidoushaShubetsuKbn: null,
        kousuu: 0,
        koukanMeyasuTime: 0
      });
    }
  }

  checkEmptyInput(row: any, index: number) {
    const countEmpty: any[] = row.jidoushaShubetsu.filter(
      (data: any) =>
        data.jidoushaShubetsuKbn === null &&
        !data.kousuu &&
        !data.koukanMeyasuTime
    );
    if (countEmpty.length > 1) {
      row.jidoushaShubetsu.splice(index, 1);
    }
  }

  searchSeibiList() {
    this.getSeibiList();
  }

  selectedWork(row: any) {
    const findIndex: any = this.seibiSelected.findIndex(
      (data: any) => data.workCd == row.workCd
    );
    if (findIndex < 0) {
      this.seibiSelected.push({ ...row });
    } else {
      this.seibiSelected.splice(findIndex, 1);
    }
  }

  unselectedWork(row: any, index: number) {
    const findIndex: any = this.seibiList.findIndex(
      (data: any) => data.workCd == row.workCd
    );
    if (findIndex >= 0) {
      this.seibiList[findIndex].isCheck = false;
    }
    this.seibiSelected.splice(index, 1);
  }

  confirmWorkDetail() {
    const data: any = this.seibiSelected.map((e: any) => {
      let tempList: any = [];
      e.jidoushaShubetsu.map((item: any) => {
        if (item.jidoushaShubetsuKbn !== null) {
          tempList.push(item);
        }
      });
      return { ...e, jidoushaShubetsu: tempList };
    });
    this.seibiSelected = [...data];
    this.saveSeibiSelected = [...data];
    this.showWorkDialog = false;
  }

  confirmShubetsuKingaku() {
    let data: any[] = [];
    if (
      this.buhinData &&
      this.buhinData.listKingaku &&
      this.buhinData.listKingaku.length !== 0
    ) {
      data = this.buhinData.listKingaku.map((e: any) => {
        return {
          jidoushaShubetsuKbn: e.jidoushaShubetsuKbn,
          kingaku: e.kingaku,
          shiyouKbn: e.shiyouKbn
        };
      });
    }
    this.buhinData = {
      ...this.buhinData,
      listKingaku: JSON.parse(JSON.stringify(data))
    };
    this.saveShubetsuKingaku = JSON.parse(JSON.stringify(data));
    this.showShubetsuDialog = false;
  }

  openKingakuDialog() {
    if (this.saveShubetsuKingaku && this.saveShubetsuKingaku.length !== 0) {
      this.saveShubetsuKingaku.map((e: any) => {
        if (e.kingaku) {
          this.focusOutZn2(false, e);
        } else {
          e.kingakuZk = 0;
        }
      });
      setTimeout(() => {
        this.buhinData = {
          ...this.buhinData,
          listKingaku: JSON.parse(JSON.stringify(this.saveShubetsuKingaku))
        };
      }, 300);
    } else {
      this.saveShubetsuKingaku = [];
      this.jidoushaShubetsuList.forEach((element: any) => {
        this.saveShubetsuKingaku.push({
          jidoushaShubetsuKbn: element.kbnKey,
          kingaku: 0,
          kingakuZk: 0,
          shiyouKbn: 1
        });
      });
      this.buhinData = {
        ...this.buhinData,
        listKingaku: JSON.parse(JSON.stringify(this.saveShubetsuKingaku))
      };
    }
    this.showShubetsuDialog = true;
  }

  // openKingakuDialog2(row: any) {
  //   this.buhinEditData = JSON.parse(JSON.stringify(row));
  //   if (
  //     this.buhinEditData.listKingaku &&
  //     this.buhinEditData.listKingaku.length !== 0
  //   ) {
  //     this.buhinEditData.listKingaku.map((e: any) => {
  //       if (e.kingaku) {
  //         this.focusOutZn2(false, e);
  //       } else {
  //         e.kingakuZk = 0;
  //       }
  //       if (e.shiyouKbn === undefined || e.shiyouKbn === null) {
  //         e.shiyouKbn = 1;
  //       }
  //     });
  //     setTimeout(() => {
  //       this.buhinEditData = {
  //         ...this.buhinEditData,
  //         listKingaku: JSON.parse(
  //           JSON.stringify(this.buhinEditData.listKingaku)
  //         )
  //       };
  //     }, 300);
  //   } else {
  //     let tempShubetsu: any = [];
  //     this.jidoushaShubetsuList.forEach((element: any) => {
  //       tempShubetsu.push({
  //         jidoushaShubetsuKbn: element.kbnKey,
  //         kingaku: 0,
  //         kingakuZk: 0,
  //         shiyouKbn: 1
  //       });
  //     });
  //     this.buhinEditData = {
  //       ...this.buhinEditData,
  //       listKingaku: JSON.parse(JSON.stringify(tempShubetsu))
  //     };
  //   }
  //   this.showShubetsuDialog2 = true;
  // }

  openWorkListDialog(row: any) {
    this.buhinEditData = { ...row };
    this.showWorkListDialog = true;
  }

  openWorkDialog() {
    this.selectWorkStep = 1;
    this.seibiList = [];
    this.seibiSelected = [...this.saveSeibiSelected];
    this.showWorkDialog = true;
  }

  checkShubetsu() {
    let statusBtn: boolean = false;
    if (this.seibiSelected && this.seibiSelected.length !== 0) {
      this.seibiSelected.forEach(element => {
        if (element.jidoushaShubetsu && element.jidoushaShubetsu.length !== 0) {
          const hasShubetsu = element.jidoushaShubetsu.findIndex(
            item => item.jidoushaShubetsuKbn !== null
          );
          if (hasShubetsu < 0) {
            statusBtn = true;
          }
        } else {
          statusBtn = true;
        }
      });
    }
    return statusBtn;
  }

  checkShubetsuOption(rowShubetsu: any, valOption: any) {
    if (rowShubetsu && rowShubetsu.length !== 0) {
      const temp = rowShubetsu.findIndex(
        (element: any) => element.jidoushaShubetsuKbn == valOption
      );
      if (temp >= 0) {
        return true;
      }
    }
    return false;
  }

  getKingaku(list: any, kbn: number) {
    const index = list.findIndex((e: any) => e.jidoushaShubetsuKbn == kbn);
    if (index >= 0) {
      return list[index].kingaku;
    }
    return 0;
  }

  clearInput() {
    this.buhinData = {
      buhinNm: "",
      kingaku: null,
      kingakuZk: null,
      buhinBunruiCd: "",
      workCd: [],
      fuelKbn: null,
      listKingaku: []
    };
    this.checkDisabled(false);
  }

  onEdit(row: any) {
    this.idEdit = row.id;
    this.buhinEditData = this.util.deepCopy(row);
    this.checkDisabled(true);
  }

  getQuantityStep(valueType: number) {
    const item = this.defaultValueTypes.find((e: any) => e.kbnKey == valueType);
    if (item) {
      return item.value;
    }
    return 1;
  }

  isBunruiSelected(bunruiId: any) {
    return this.bunruiSelectedList.indexOf(bunruiId) > -1;
  }

  showBunrui(bunruiId: any) {
    if (this.bunruiSelectedList.length == 0) {
      return true;
    } else {
      return this.isBunruiSelected(bunruiId);
    }
  }

  onSelectShubetsu(tab: any, event: any) {
    this.bunruiSelectedList = [];
  }

  onSelectBunrui(bunruiId: number) {
    const findIndex = this.bunruiSelectedList.indexOf(bunruiId);
    if (findIndex === -1) {
      this.bunruiSelectedList.push(bunruiId);
    } else {
      this.bunruiSelectedList.splice(findIndex, 1);
    }
  }

  async getFeeList() {
    /** 2022-07-13 sh #7979(BQR1010) ommit feeId. [START] */
    /* 部品は、料金プランに対応していないので、ひとまず、選択できないようにしておく。*/
    // this.feeList = await this.shatenService.getInspectMenuFee(
    //   this.form.version
    // );
    // const feeId = this.util.getFeeIdBase(this.feeList);
    // if (feeId) {
    //  this.$set(this.form, "sknInspectSeibiFeeId", feeId);
    // }
    /** 2022-07-13 sh #7979(BQR1010) ommit feeId. [END] */
    this.getBuhinList(true);
  }

  selectFee() {
    this.getBuhinList(true);
  }

  toggleStar() {
    this.hasExtensionId = !this.hasExtensionId;
    this.setActiveShubetsu();
  }

  isHasExtensionId(item: any) {
    return (
      item.listKingaku.filter(
        (k: any) => k.sknInspectSeibiBuhinKingakuExtensionId
      ).length > 0
    );
  }

  setActiveShubetsu() {
    if (this.buhinList.length > 0) {
      let val = "";
      if (this.hasExtensionId) {
        const found = this.buhinList.find((item: any) =>
          item.items.some((bunrui: any) =>
            bunrui.items.some((buhin: any) =>
              buhin.listKingaku.some(
                (k: any) => k.sknInspectSeibiBuhinKingakuExtensionId !== null
              )
            )
          )
        );
        if (found) {
          val = found.buhinShubetsuCd;
        }
      } else {
        val = this.buhinList[0].buhinShubetsuCd;
      }
      this.$set(this, "activeBuhinShubetsu", val);
      this.$set(this, "bunruiSelectedList", []);
    }
  }
}
